import { get } from "@ember/object"
import Component from "@glimmer/component"
import type { Group } from "@shared/models/group"
import BelongTo from "cc-frontend/helpers/belong-to"
import { use } from "ember-could-get-used-to-this"

interface Signature {
  Args: {
    group: Group
  }
}

export default class SchoolEditPayment extends Component<Signature> {
  @use fiscalGroup = new BelongTo(() => [this.args.group, "fiscalGroup"])
  @use managingGroup = new BelongTo(() => [this.fiscalGroup.content, "managingGroup"])

  get stateName() {
    let fg = get(this.fiscalGroup, "content")
    if (fg === null) return ""
    let attrs = get(fg, "attributes")
    let state = get(attrs, "state")
    let warningStartsAt = get(state, "warningStartsAt")
    let isAfterWarningDate = dateFns.isBefore(get(state, "warningStartsAt"), new Date())
    let currentValue = get(state, "currentValue")
    let postfix = warningStartsAt && isAfterWarningDate ? "-warning" : ""
    return `${currentValue}${postfix}`
  }

  get daysUntilEndsAt() {
    let fg = get(this.fiscalGroup, "content")
    if (fg === null) return ""
    let attrs = get(fg, "attributes")
    let state = get(attrs, "state")
    if (this.fiscalGroup.content === null) return 0
    return dateFns.differenceInDays(get(state, "endsAt"), new Date())
  }

  get daysUntilEndsAtString() {
    let days = this.daysUntilEndsAt + 1
    return days === 1 ? `${days} day` : `${days} days`
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "School::Edit::Payment": typeof SchoolEditPayment
  }
}
